import { render, staticRenderFns } from "./WOGeneralInfo.vue?vue&type=template&id=2d1b0c3a&"
import script from "./WOGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./WOGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./WOGeneralInfo.vue?vue&type=style&index=0&id=2d1b0c3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports